import { getFetch, postFetchWithBody, postFetchWithToken } from "../../utils/fetch";

async function getDefects(page) {
  const data = await getFetch(`/defects?page=${page}`);
  if (data.status !== "error") {
    return {
      status: "success",
      message: data,
    };
  } else {
    return {
      status: data.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
async function storeDefects(form) {
  if (form.get('title') === '') {
    return {
      status: 'error',
      message: 'فیلد نقص فنی الزامی است!',
    }
  }

  const res = await postFetchWithToken("/defects/store", form);
  if(res.status !== 'error'){
    return {
      status:'success',
      message:'نقص فنی با موفقیت ایجاد شد'
    }
  }else{
    return {
      status:res.status,
      message:res.message
    }
  }

}
async function deleteDefect(id) {
  const res = await postFetchWithBody(`/defects/delete`, { id: id });
  if (res.status !== "error") {
    return {
      status: "success",
      message: res,
    };
  } else {
    return {
      status: res.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
export { getDefects, storeDefects,deleteDefect };
